module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = 260
// module chunks = 0